// extracted by mini-css-extract-plugin
export default {"scrollContainer":"create-google-sheets-audience_scrollContainer__FrXbr"};